"use client";
import React, { useRef, useEffect } from "react";
import AdviceCourseCard from "../cards/advice-course/advicecoursecard";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { FreeMode, Navigation, Pagination } from "swiper/modules";
import { GA4DataLayer } from "@packages/lib/utlils/helper-function";
import { GAConstants } from "@packages/shared-components/services/constants";
const Advicecourseslidercomponents = ({
  articledata,
  iscontentPreview,
  heading,
  parentCategory,
  sub_Category,
  commonGAAttrs
}: any) => {
  const swiperRef = useRef<any>(null);
  const isPaginationClick = useRef(false);
  const handleSlide = () => {
    if (!isPaginationClick.current) {
    GA4DataLayer({
    event: GAConstants.track_event,
    event_name: "carousel_navigation",
    click_text: heading,
    // field:"arrow"
    navigation_category:'arrow',
    ...commonGAAttrs
    });
    }
  };

  const handleSwiperInit = (swiper: any) => {
    swiperRef.current = swiper;
    
    // Add click listeners to pagination bullets scoped to this swiper instance
    setTimeout(() => {
      const bullets = swiper.el.querySelectorAll('.swiper-pagination-bullet');
      bullets.forEach((bullet: Element) => {
        bullet.addEventListener('click', () => {
          isPaginationClick.current = true;
          GA4DataLayer({
            event: GAConstants.track_event,
            event_name: "carousel_navigation",
            click_text: heading,
            navigation_category:'dot',
            ...commonGAAttrs
            });
          setTimeout(() => {
            isPaginationClick.current = false;
          }, 100);
        });        
      });
    }, 100);
  };
  return (
    <>
      {articledata && (
        <Swiper
          onSwiper={handleSwiperInit}
          pagination={{ clickable: true }}
          navigation={true}
          onSlideNextTransitionStart={handleSlide}
          onSlidePrevTransitionStart={handleSlide}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 8,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          }}
          modules={[FreeMode, Pagination, Navigation]}
          className="MultiSwiper"
        >
          {articledata?.map((items: any, index: number) => (
            <SwiperSlide className="!h-auto" key={index + 1}>
              <AdviceCourseCard
                jsondata={items}
                index={index}
                iscontentPreview={iscontentPreview}
                heading={heading}
                parentCategory={parentCategory}
                sub_Category={sub_Category}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </>
  );
};

export default Advicecourseslidercomponents;
